<template>
    <on-click-outside :do="hide">
        <div 
            ref="submenu" 
            class="submenu" 
            :class="dropdownClass"
        >
            <slot />
        </div>
    </on-click-outside>
</template>

<script>
    import Popper from 'popper.js';

    export default {
        props: {
            placement: {
                required: false,
                type: String,
                default: 'auto',
            },
            dropdownClass: {
                required: false,
                type: String,
                default: '',
            },
        },
        data() {
            return {
                expanded: false,
            };
        },
        created() {
            this.$nextTick(() => {
                new Popper(this.$parent.$el, this.$refs.submenu, {
                    placement: this.placement,
                });
            });
        },
        methods: {
            hide() {
                this.$emit('hide');
            },
        },
    };
</script>